import { render, staticRenderFns } from "./policy-info-table.vue?vue&type=template&id=afd048d8&scoped=true&"
import script from "./policy-info-table.vue?vue&type=script&lang=js&"
export * from "./policy-info-table.vue?vue&type=script&lang=js&"
import style0 from "./policy-info-table.vue?vue&type=style&index=0&id=afd048d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd048d8",
  null
  
)

export default component.exports